/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { Form } from 'formik';
import { Button, CircularProgress, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getAllApplication } from '../../../../../store/reducers/application/applicationAction';
import { getAllAuthProvider } from '../../../../../store/reducers/authProvider/authProviderActions';
import { getAllGetchkdUsers } from '../../../../../store/reducers/getchkdUser/getchkdUserAction';
import { getAllKeyCloakUsers } from '../../../../../store/reducers/keyCloak/keyCloakAction';

const MappingCreationForm = ({ values, handleBlur, handleChange, errors, touched, handleClose, isSubmitting }) => {
    const dispatch = useDispatch();
    const applications = useSelector(state => state.application.applications);
    const authProviders = useSelector(state => state.authProvider.authProviders)
    const getchkdUsers = useSelector(state => state.getchkdUser.getchkdUsers);
    const keyCloakUsers = useSelector(state => state.keycloak.keyCloakUsers);

    React.useEffect(() => {
        const fetchData = async () => {
            try {
                await Promise.all([
                    dispatch(getAllApplication()).unwrap(),
                    dispatch(getAllAuthProvider()).unwrap(),
                    dispatch(getAllGetchkdUsers()).unwrap(),
                    dispatch(getAllKeyCloakUsers({ "realm": "getchkd" })).unwrap(),
                ]);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [dispatch]);


    return (

        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Create New User Mapping</Typography>

            <Form>
                <Grid container spacing={4}>
                    {values.hasOwnProperty("getChkdID") && <Grid item xs={12} md={12} sm={12}>
                        <FormControl fullWidth error={Boolean(touched.getChkdID && errors.getChkdID)}>
                            <InputLabel htmlFor="outlined-status">Getchkd User</InputLabel>
                            <Select
                                value={values.getChkdID}
                                variant="outlined"
                                name="getChkdID"
                                label="Getchkd User"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                style={{ color: 'white' }}
                            >
                                {getchkdUsers?.Records?.length > 0 && getchkdUsers?.Records?.map((item) => (
                                    <MenuItem value={item.getChkdID}>
                                        {item.email}
                                    </MenuItem>
                                ))}


                            </Select>
                            {errors.getChkdID && <FormHelperText style={{ color: "red" }} >{errors.getChkdID}</FormHelperText>}

                        </FormControl>

                    </Grid>}
                    {values.hasOwnProperty("appUserID") && <Grid item xs={12} md={12} sm={12}>
                        <FormControl fullWidth error={Boolean(touched.appUserID && errors.appUserID)}>
                            <InputLabel htmlFor="outlined-status">Keycloak User</InputLabel>
                            <Select
                                value={values.appUserID}
                                variant="outlined"
                                name="appUserID"
                                label="Keycloak User"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                style={{ color: 'white' }}
                            >
                                {keyCloakUsers?.length > 0 && keyCloakUsers?.map((item) => (
                                    <MenuItem value={item.id}>
                                        {item.email}
                                    </MenuItem>
                                ))}


                            </Select>
                            {errors.appUserID && <FormHelperText style={{ color: "red" }} >{errors.appUserID}</FormHelperText>}

                        </FormControl>

                    </Grid>}

                    {values.hasOwnProperty("applicationID") && <Grid item xs={12} md={12} sm={12}>


                        <FormControl fullWidth error={Boolean(touched.applicationID && errors.applicationID)}>
                            <InputLabel htmlFor="outlined-status">Application</InputLabel>
                            <Select
                                value={values.applicationID}
                                variant="outlined"
                                name="applicationID"
                                label="Owner"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                style={{ color: 'white' }}
                            >
                                {applications?.Records?.length > 0 && applications?.Records?.map((item) => (
                                    <MenuItem value={item.applicationID}>
                                        {item.applicationName}
                                    </MenuItem>
                                ))}


                            </Select>
                            <FormHelperText style={{ color: "red" }} >{errors.applicationID}</FormHelperText>

                        </FormControl>

                    </Grid>}
                    {values.hasOwnProperty("authProviderID") && <Grid item xs={12} md={12} sm={12}>


                        <FormControl fullWidth error={Boolean(touched.authProviderID && errors.authProviderID)}>
                            <InputLabel htmlFor="outlined-status">Identity Provider</InputLabel>
                            <Select
                                value={values.authProviderID}
                                variant="outlined"
                                name="authProviderID"
                                label="Identity Provider"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                style={{ color: 'white' }}
                            >
                                {authProviders?.length > 0 && authProviders?.map((item) => (
                                    <MenuItem value={item.authProviderID}>
                                        {item.authProviderName}
                                    </MenuItem>
                                ))}


                            </Select>
                            <FormHelperText style={{ color: "red" }} >{errors.authProviderID}</FormHelperText>

                        </FormControl>
                    </Grid>
                    }

                    <Grid item xs={12} md={12} sm={12}>
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            style={{ marginTop: '20px' }}
                            disabled={isSubmitting}>
                            {isSubmitting &&
                                <CircularProgress size={24} color='success' style={{ marginLeft: '10px' }} />} Save
                        </Button>
                        <Button variant="outlined" onClick={() => handleClose()} style={{ marginTop: '20px', marginLeft: '10px' }}>close</Button>

                    </Grid>

                </Grid>
            </Form>
        </>
    )

}
export default MappingCreationForm;